import React from "react";
import Modal from "../../../../elements/Modal";
import ManageTestimonials from "../ManageTestimonials";

const ManageTestimonialsModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update" : "Create New "}
    >
      <ManageTestimonials getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageTestimonialsModal;
